import { logError } from '~shared/observability/observability';
import { Offer } from '~entities/offer/model/offer.types';
import { CartItem, LastBooking, Session } from '../model/session.types';
import {
  AddToCartDto,
  LastBookingDto,
  SessionDto,
  UpdateCartItemDto,
} from '~shared/api/api.types';

export const transformSessionDtoToSession = ({
  items,
  ...sessionDto
}: SessionDto): Session => {
  return {
    ...sessionDto,
    cart: items.map(({ roomCategoryId, packageGroupId, ...offer }) => ({
      ...offer,
      roomId: roomCategoryId,
      packageId: packageGroupId,
    })),
    promotionCode: sessionDto.promotion?.code,
  };
};

export const transformOfferToAddToCartDto = (offer: Offer): AddToCartDto => {
  // TODO: in future no throw errors, make more type safe api
  if (
    !offer.type ||
    !offer.adults ||
    !offer.children ||
    !offer.price ||
    !offer.rateId ||
    !offer.roomId
  ) {
    const missingFields: string[] = [];
    if (!offer.type) missingFields.push('type');
    if (!offer.adults) missingFields.push('adults');
    if (!offer.children) missingFields.push('children');
    if (!offer.price) missingFields.push('price');
    if (!offer.rateId) missingFields.push('rateId');
    if (!offer.roomId) missingFields.push('roomId');

    const message = `Invalid offer: missing ${missingFields.join(', ')}`;
    logError(new Error(message), {
      // SigNoz has no fingerprint concept, so grouping happens at query time
      // on error.fingerprint. logError derives it from the message, which also
      // covers the unhandled rejection from the throw below — that arrives as
      // a separate record and would otherwise group by its own message.
      kind: 'invalid-offer',
      missingOfferFields: missingFields.join(','),
      offer: { ...offer } as Record<string, unknown>,
    });
    throw new Error(message);
  }

  return {
    type: offer.type,
    arrivalDay: offer.arrivalDay,
    nights: offer.nights,
    adults: offer.adults,
    children: offer.children,
    price: offer.price,

    rateId: offer.rateId,
    roomCategoryId: offer.roomId,

    lastMinutePackageId: offer.lastMinutePackageId,
    packageGroupId: offer.packageId,
    packageCategoryId: offer.packageCategoryId,
  };
};

export const transformCartItemToUpdateCartItemDto = ({
  roomId,
  ...cartItem
}: CartItem): UpdateCartItemDto => {
  return {
    ...cartItem,
    roomCategoryId: roomId,
  };
};

export const transformLastBookingDtoToLastBooking = (
  lastBookingDto: LastBookingDto,
): LastBooking => {
  return {
    ...lastBookingDto,
  };
};
